import React, { ComponentType, Suspense } from 'react';

import { Spinner } from '~/components/_tclOverrides/Spinner/Spinner';

const lazyFallback = <Spinner relativePosition loading transparent />;

/** Code-splits a route page. Use at module scope in `routes/index.ts` (same composition as `withPageTitle`). */
export const withLazyLoad = <P extends object>(factory: () => Promise<{ default: ComponentType<P> }>) => {
  const LazyComponent = React.lazy(factory);

  const WithLazyLoad = (props: P) => (
    <Suspense fallback={lazyFallback}>
      <LazyComponent {...props} />
    </Suspense>
  );

  return WithLazyLoad;
};

export default withLazyLoad;
